import React from 'react';
import { Col, Row, Alert } from 'antd';

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null, errorInfo: null };
	}
	
	componentDidCatch(error, errorInfo) {
		// Display fallback UI
		this.setState({
	      error: error,
	      errorInfo: errorInfo
	    });
		// You can also log the error to an error reporting service
		//logErrorToMyService(error, info);
	}
	
	render() {
		if (this.state.errorInfo) {
			
			
			const ErrorComponent = <details style={{ whiteSpace: 'pre-wrap' }}>
					            {this.state.error && this.state.error.toString()}
					            <br />
					            {this.state.errorInfo.componentStack}
					          </details>;
			
		    return (
		      <div className="main-container dashboard">
		        <Row gutter={40} type="flex" align="middle" justify="space-around">
					<Col xs={24} sm={24} md={10}>
						<Alert
					      message="Error"
					      description={ErrorComponent}
					      type="error"
					      showIcon
					    />
					</Col>
				</Row>
			</div>
		    )
		}
		return this.props.children;
	}
}